<!--
  This work has been created or enhanced by
    Markus Luckey, 2025, KERNBLICK GmbH

  This file is covered by the EU PL 1.2 license.
  You may obtain a copy of the licence at
  https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
-->

<template>
  <div class="content">
    <h1>{{ $t('accessDenied') }}</h1>
    <p>
      <span>{{ $t('returnHome') }}</span>
    </p>
  </div>
</template>

<script>
export default {
}
</script>
